import { NotificationType } from "../../constants/Enums";
import { AppDispatch } from "../../dataManagement/uiDb/UiDb";
import MyMessagesThunk from "../thunks/MyMessagesThunk";

/**
 * Performs an offer operation and calls the provided function with the result.
 * @param dispatch - Redux dispatch function.
 * @param offerPrice - The offer price amount.
 * @param productId - The product ID to make offer for.
 * @param triggerNotification - Function to handle notifications (e.g., triggerNotification).
 * @param onSuccess - Callback function to execute on successful offer.
 */
export const performOffer = (
  dispatch: AppDispatch,
  offerPrice: number,
  productId: string,
  triggerNotification: (message: string, type: NotificationType) => void,
  onSuccess?: () => void,
): void => {
  if (offerPrice <= 0) {
    triggerNotification(
      "Offer price must be greater than 0",
      NotificationType.WARNING,
    );
    return;
  }

  if (!productId) {
    triggerNotification("Product ID is required", NotificationType.ERROR);
    return;
  }

  dispatch(MyMessagesThunk.makeOffer({ offerPrice, productId }))
    .unwrap()
    .then(() => {
      triggerNotification(
        `Offer made for ₹${offerPrice}`,
        NotificationType.SUCCESS,
      );
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((error: { message: any }) => {
      triggerNotification(
        `Failed to make offer: ${error.message}`,
        NotificationType.ERROR,
      );
    });
};
